import {
    Container,
    FormControl,
    FormGroup,
    FormHelperText,
    FormLabel,
    Switch,
    TextField,
    makeStyles,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import SRCards from "../../components/SRCards";
import SelectCompany from "../../components/SelectCompany";
import { useEffect, useState } from "react";
import CompanyApi from "../../services/company.service";

const useStyles = makeStyles({
    formDiv: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        height: "275px",
        marginTop: "40px",
    },
    formControl: {
        width: "50%",
    },
    formGroup: {
        marginTop: "12px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    textField: {
        display: "inline",
    },
    label: {
        color: "#321d00",
        display: "inline",
        width: "50%",
    },
    button: {
        width: "10%",
        margin: "0px 0px",
        padding: "5px 5px",
    },
});

const dateValidation = (dateString: string) => {
    if (!/^\d{2}-\d{2}-\d{4}$/.test(dateString)) return false;

    var parts = dateString.split("-");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;

    return day > 0 && day <= monthLength[month - 1];
};

const RenewalReminderBanner = () => {
    const [isExpiringSoon, setIsExpiringSoon] = useState(true);
    const classes = useStyles();
    const [dateInputError, setDateInputError] = useState(false);
    const [dateInputValue, setDateInputValue] = useState<any>(null);
    const [confirmMsg, setConfirmMsg] = useState("");
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState("");
    const [pageResponse, setPageResponse] = useState("");
    const apiservices = new CompanyApi();

    const cancel = () => {
        setDialog(false);
    };

    const update = async () => {
        const companyId = localStorage.getItem("company-id");

        try {
            let rrbBody: any = {
                isExpiringSoon,
                companyId,
            };
            if (isExpiringSoon) rrbBody.expiringDate = dateInputValue;

            const result = await apiservices.updateCompanyReminderBannerDetails(
                rrbBody
            );
            setPageResponse("Renewal Banner has successfully updated!!");
            setSnackBar("success");
        } catch (error: any) {
            console.log(error);
            setPageResponse("Failed to update Renewal Banner");
            setSnackBar("error");
        }
        setDialog(false);
    };

    const openConfirmDialog = () => {
        setConfirmMsg(
            `Are you sure you want to update Reminder Banner Details!`
        );
        setDialog(true);
    };

    useEffect(() => {
        if (!isExpiringSoon) setDateInputError(false);
    }, [isExpiringSoon]);
    return (
        <>
            <SRCards />
            <Container>
                <SelectCompany />

                <div className={classes.formDiv}>
                    <h3>{"Renewal update"}</h3>
                    <FormControl className={classes.formControl}>
                        <FormGroup className={classes.formGroup}>
                            <FormLabel className={classes.label}>
                                {"Plan Expired"}
                            </FormLabel>
                            <Switch
                                checked={isExpiringSoon}
                                onChange={(event: any) => {
                                    setIsExpiringSoon(event.target.checked);
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        </FormGroup>
                        <FormGroup className={classes.formGroup}>
                            <FormLabel className={classes.label}>
                                {"Expiry Date"}
                            </FormLabel>
                            <TextField
                                className={classes.textField}
                                autoComplete="off"
                                id="outlined-basic"
                                label="MM-DD-YYYY"
                                variant="outlined"
                                onChange={(event) => {
                                    const dateValue = event.target.value;
                                    if (
                                        !dateValidation(dateValue) &&
                                        isExpiringSoon
                                    )
                                        setDateInputError(true);
                                    else {
                                        setDateInputError(false);
                                    }
                                    setDateInputValue(dateValue);
                                }}
                            />
                            {dateInputError && (
                                <FormHelperText error>
                                    {
                                        "Date value must be in MM-DD-YYYY format and valid"
                                    }
                                </FormHelperText>
                            )}
                        </FormGroup>
                    </FormControl>
                    <Button
                        className={classes.button}
                        onClick={() => {
                            if (
                                isExpiringSoon &&
                                !dateValidation(dateInputValue)
                            ) {
                                setPageResponse("Expiry Date is invalid");
                                setSnackBar("error");
                            } else openConfirmDialog();
                        }}
                        variant="outlined"
                    >
                        Update RRB
                    </Button>
                </div>

                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false);
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirmation!"}
                    </DialogTitle>
                    <DialogContent>{confirmMsg}</DialogContent>
                    <DialogActions>
                        {confirmMsg !== "Processing..." && (
                            <>
                                <Button
                                    onClick={async () => {
                                        setConfirmMsg("Processing...");
                                        update();
                                    }}
                                >
                                    Confirm
                                </Button>
                                <Button onClick={() => cancel()} autoFocus>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </DialogActions>
                </Dialog>
                <Snackbar
                    open={snackBar === "" ? false : true}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar("");
                    }}
                >
                    <Alert
                        severity={snackBar === "error" ? "error" : "success"}
                        onClose={() => {
                            setSnackBar("");
                        }}
                    >
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    );
};

export default RenewalReminderBanner;
